import { Form, Button, ButtonToolbar, Schema, FlexboxGrid, useToaster, Message } from 'rsuite';
import { useHistory } from "react-router-dom";
import ReactDOM from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from 'react';
import { changePassword, getById } from 'services/microsoftGraphApi';
import { RequestVM } from 'models/requestVM';
import CryptoJS from 'crypto-js';
import ClipLoader from 'react-spinners/ClipLoader';
import React from 'react';

const regexPass = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#.])[A-Za-z\d@$!%*?&#.]{10,15}$/;

function CambioContrasena(props) {

  const [userName, setUserName] = useState();
  const [mail, setMail] = useState();
  const [loadingInProgress, setLoading] = useState(false);
  const [visible, setVisible] = React.useState(false);
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [isDisabledconfirmpass, setDisibilityConfirmPass] = useState(true);  
  const [isDisabledbutton, setDisibilityButton] = useState(true);

  const handleChange = () => {
    setVisible(!visible);
    };

    useEffect(() => {
        const isValid =
            regexPass.test(newPass) &&
            regexPass.test(confirmPass) &&
            newPass === confirmPass;

        setDisibilityButton(!isValid);
    }, [newPass, confirmPass]);

    const handleChangeNewPass = (val) => {
        setNewPass(val);
        setDisibilityConfirmPass(!regexPass.test(val));
    };

    const handleChangeConfirmPass = (val) => {
        setConfirmPass(val);
    };

  const { StringType } = Schema.Types;
  const model = Schema.Model({
    password: StringType().isRequired('Este campo es requerido'),
    verifyPassword: StringType()
      .addRule((value, data) => {
        if (newPass !== value) {
          return false;
        }
        return true;
      }, 'Las contraseñas no coinciden')
      .isRequired('Este campo es requerido')
  });  

  const toaster = useToaster();

  const history = useHistory();

  const readQueryParams = async () => {
    if (props.history != undefined)
    {
      const respuesta = props.history.location.pathname.replace('/cambiocontrasena/','');    
      // Decrypt
      var bytes = CryptoJS.AES.decrypt(respuesta, 'my-secret-key@123');
      var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  
      if (decryptedData != null && decryptedData != undefined)
      {
        callMicrosoftGraphAPI(decryptedData);
      }
      else {
        toaster.push(
          <Message showIcon type="warning" header="Atención" duration={4000}>
              Debe ingresar la cuenta usuario colaborador y contraseña.
          </Message>, { placement: 'topEnd' });
  
          goBack();
      }
    }
  };
  
    useEffect(() => {
        readQueryParams();
    }, []);
  
  const callMicrosoftGraphAPI = async (id) => {
    const respuesta = await getById(id);

    if (respuesta.success)
    {
      let userName = respuesta.data.userPrincipalName;
      let email = respuesta.data.mail;

      setUserName(userName);
      setMail(email);
    }
    else {
      toaster.push(
        <Message showIcon type="warning" header="Atención" duration={4000}>
            No se encontró información para la cuenta usuario colaborador y contraseña ingresada.
        </Message>, { placement: 'topEnd' });

      goBack();
    }
  };

  const callMicrosoftGraphAPI2 = async () => {
    if (newPass != null && confirmPass != null)
    {
      setLoading(true);
      
      let model = new RequestVM(userName, "", newPass, false, "", mail);

      const respuesta = await changePassword(model);

      if (respuesta.success) {
        setLoading(false);

        toaster.push(
          <Message showIcon type="success" header="Atención" duration={4000}>
              Se ha modificado correctamente la contraseña.
          </Message>, { placement: 'topEnd' });
          
        goBack();
      }
      else {
        setLoading(false);

        toaster.push(
          <Message showIcon type="error" header="Atención" duration={4000}>
              No se ha podido recuperar la contraseña para la cuenta usuario colaborador ingresada.
          </Message>, { placement: 'topEnd' });        
      }
    }
    else 
    {
      toaster.push(
        <Message showIcon type="warning" header="Atención" duration={4000}>
            Debe seleccionar un método de recuperación antes de continuar.
        </Message>, { placement: 'topEnd' });
    }
  };  

  const goBack = (() => {
    let path = '/comprobar'; 
    history.push(path);
  });

  const renderCambioContrasena = (
    <Form layout='vertical'>              
      <Form model={model}>
        <Form.Group controlId="newPassword">
          <Form.ControlLabel>Nueva Contraseña</Form.ControlLabel>
          <Form.Control type='password' name="password" autoComplete="off" minLength={10} maxLength={15} onChange={handleChangeNewPass}/>
          <Form.HelpText tooltip>Mínimo 10 y máximo 15 caracteres, al menos una letra mayúscula, una letra minúscula, un número y un carácter especial</Form.HelpText>
        </Form.Group>                
        <Form.Group controlId="verifyPassword">
          <Form.ControlLabel>Confirmar Contraseña</Form.ControlLabel>
          <Form.Control type='password' name="verifyPassword" autoComplete="off" minLength={10} maxLength={15} onChange={handleChangeConfirmPass}/>
          <Form.HelpText tooltip>Mínimo 10 y máximo 15 caracteres, al menos una letra mayúscula, una letra minúscula, un número y un carácter especial</Form.HelpText>
        </Form.Group>
        <ButtonToolbar style={{ marginTop: '5%', textAlign: 'right' }}>
          <Button appearance="primary" color='blue' type="submit" onClick={callMicrosoftGraphAPI2} disabled={isDisabledbutton}>
            Confirmar
          </Button>
          <Button appearance='subtle' color='green' type="submit" onClick={goBack}>
            Volver
          </Button>
        </ButtonToolbar>
      </Form>             
    </Form>
  );  

  return (
    <FlexboxGrid justify="center" align="middle" style={{ marginTop: '5%', backgroundColor: '#FFF' }}>
      {loadingInProgress ? (<ClipLoader color={'#000000'} size={150} />) : (renderCambioContrasena)}      
    </FlexboxGrid>    
  );
}

const rootElement = document.getElementById('root');

const root = ReactDOM.createRoot(rootElement);

root.render(<CambioContrasena/>);

export default CambioContrasena;